import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import JsonLdScript from '@/components/json-ld/JsonLdScript';
import { buildCaseStudyJsonLd } from '@/lib/case-study-schema';
interface Props {
  page: Parameters<typeof buildCaseStudyJsonLd>[0];
}
const CaseStudyJsonLd: FC<Props> = t0 => {
  const $ = _c(4);
  const {
    page
  } = t0;
  let t1;
  if ($[0] !== page) {
    t1 = buildCaseStudyJsonLd(page);
    $[0] = page;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <JsonLdScript data={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default CaseStudyJsonLd;